import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from '../plugin'
import { State } from '../state'

/**
 * Clears scenario-scoped duplicate detection state when the employees
 * collection changes context.
 */
export const resetOnContextChange = store.reducers.extra(
  (_feature: Plugin['feature'], plugin: Plugin) =>
    new store.reducers.ExtraReducer({
      on: [plugin.collection.feature.actions.changeContext],
      reduce: () => State.INITIAL,
    }),
)
